import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Button, Col, Dropdown, Nav, Row } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import Avatar from "../components/Avatar";

import img6 from "../assets/img/img6.jpg";
import img7 from "../assets/img/img7.jpg";
import img8 from "../assets/img/img8.jpg";
import img9 from "../assets/img/img9.jpg";
import img10 from "../assets/img/img10.jpg";
import img11 from "../assets/img/img11.jpg";
import img12 from "../assets/img/img12.jpg";
import img13 from "../assets/img/img13.jpg";
import img14 from "../assets/img/img14.jpg";
import img15 from "../assets/img/img15.jpg";
import img16 from "../assets/img/img16.jpg";
import img17 from "../assets/img/img17.jpg";
import img18 from "../assets/img/img18.jpg";
import img19 from "../assets/img/img19.jpg";

export default function Contacts() {
  useEffect(() => {
    document.body.classList.add('page-app')
    return () => {
      document.body.classList.remove('page-app')
    }
  }, []);

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="header-link"
    >
      {children}
    </Link>
  ));

  const contactGroup = [
    {
      "group": "A",
      "items": [
        {
          "status": "offline",
          "thumb": img11,
          "name": "Abigaile Johnson",
          "contact": "+1-234-567-890",
          "selected": true
        }, {
          "status": "online",
          "thumb": img9,
          "name": "Angeline Cantones",
          "contact": "angeline@cantones.com"
        }, {
          "status": "online",
          "initial": "primary",
          "name": "Allan Rey Palban",
          "contact": "allanrey@palban.com"
        }, {
          "status": "online",
          "initial": "pink",
          "name": "Aileen Palomares",
          "contact": "aileen@palomares.com"
        }
      ]
    }, {
      "group": "B",
      "items": [
        {
          "status": "offline",
          "thumb": img14,
          "name": "Bellamy Newton",
          "contact": "+1-890-1234-567"
        }, {
          "status": "online",
          "initial": "purple",
          "name": "Brenda Wilkins",
          "contact": "+1-567-8901-234"
        }, {
          "status": "online",
          "thumb": img17,
          "name": "Bob Wise",
          "contact": "bob@wise.com"
        }
      ]
    }, {
      "group": "C",
      "items": [
        {
          "status": "offline",
          "thumb": img6,
          "name": "Clifford Solis",
          "contact": "+1-001-2236-445"
        }
      ]
    }, {
      "group": "D",
      "items": [
        {
          "status": "offline",
          "thumb": img7,
          "name": "Daniel Stewart",
          "contact": "+1-201-2345-876"
        }, {
          "status": "offline",
          "thumb": img10,
          "name": "David Barrett",
          "contact": "+1-323-5432-101"
        }, {
          "status": "offline",
          "thumb": img8,
          "name": "Dinah Webster",
          "contact": "dinah@webster.com"
        }, {
          "status": "online",
          "initial": "success",
          "name": "Dindo Robertson",
          "contact": "dindo@robertson.com"
        }
      ]
    }, {
      "group": "E",
      "items": [
        {
          "status": "online",
          "thumb": img11,
          "name": "Emily Blunt",
          "contact": "emily@blunt.com"
        }
      ]
    }, {
      "group": "G",
      "items": [
        {
          "status": "online",
          "initial": "info",
          "name": "Georgie Kavkaz",
          "contact": "georgie@kavkaz.com"
        }, {
          "status": "online",
          "initial": "danger",
          "name": "Guztavo Diaz",
          "contact": "+2 345 6789 012"
        }
      ]
    }, {
      "group": "H",
      "items": [
        {
          "status": "online",
          "thumb": img12,
          "name": "Honey Lee",
          "contact": "+9 012 3456 789"
        }
      ]
    }, {
      "group": "J",
      "items": [
        {
          "status": "offline",
          "thumb": img19,
          "name": "Joanna Cesar",
          "contact": "+7 890 1234 567"
        }, {
          "status": "online",
          "thumb": img18,
          "name": "Jane Doe",
          "contact": "+5 678 9012 345"
        }, {
          "status": "online",
          "thumb": img16,
          "name": "Janice Bentulan",
          "contact": "janice@bentulan.com"
        }
      ]
    }, {
      "group": "M",
      "items": [
        {
          "status": "online",
          "initial": "indigo",
          "name": "Marie Recamada",
          "contact": "marie@recamadas.org"
        }
      ]
    }, {
      "group": "P",
      "items": [
        {
          "status": "online",
          "initial": "warning",
          "name": "Pamela Anderson",
          "contact": "pamela@andreson.com"
        }
      ]
    }, {
      "group": "S",
      "items": [
        {
          "status": "online",
          "thumb": img15,
          "name": "Samantha Perez",
          "contact": "+3 456 7890 123"
        }
      ]
    }, {
      "group": "Z",
      "items": [
        {
          "status": "online",
          "thumb": img13,
          "name": "Zenaida Sanchez",
          "contact": "+4 567 8901 234"
        }
      ]
    }
  ];

  // toggle contact sidebar in mobile
  const [isSidebarShow, setSidebarShow] = useState(false);

  const sidebarShow = () => {
    setSidebarShow(!isSidebarShow);
  };

  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        {/* Enhanced Header Section */}
        <div className="text-center mb-5">
          <div className="d-flex align-items-center justify-content-center mb-3">
            <i className="ri-contacts-line fs-1 text-primary me-3"></i>
            <h1 className="display-6 fw-bold text-primary mb-0">Contacts</h1>
          </div>
          <p className="lead text-muted">Manage your contacts and stay connected</p>
        </div>

        <div className={"contact-panel " + (isSidebarShow? "sidebar-show": "")}>
          <PerfectScrollbar className="contact-sidebar">
            <div className="mb-4">
              <Button variant="primary" className="btn-contact-new shadow-lg rounded-pill px-4 py-3 fw-semibold">
                <i className="ri-add-fill me-2"></i> Add New Contact
              </Button>
            </div>

            <Nav className="nav-sidebar">
              <Nav.Link href="" className="active rounded-3 mb-2">
                <i className="ri-contacts-fill me-3"></i>All Contacts 
                <span className="badge bg-primary ms-auto rounded-pill">264</span>
              </Nav.Link>
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-archive-line me-3"></i> Archive
              </Nav.Link>
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-group-line me-3"></i> Other Contacts 
                <span className="badge bg-secondary ms-auto rounded-pill">25</span>
              </Nav.Link>
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-delete-bin-line me-3"></i> Trash
              </Nav.Link>
            </Nav>

            <hr className="my-4" />

            <label className="sidebar-label mb-3 fw-bold text-primary">
              <i className="ri-price-tag-line me-2"></i>Labels
            </label>
            <Nav className="nav-sidebar">
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-google-line me-3 text-danger"></i> From Google 
                <span className="badge bg-danger ms-auto rounded-pill">65</span>
              </Nav.Link>
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-smartphone-line me-3 text-info"></i> From iPhone 
                <span className="badge bg-info ms-auto rounded-pill">24</span>
              </Nav.Link>
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-upload-cloud-line me-3 text-success"></i> 11/08 Import 
                <span className="badge bg-success ms-auto rounded-pill">36</span>
              </Nav.Link>
            </Nav>

            <hr className="my-4" />

            <Nav className="nav-sidebar">
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-download-2-line me-3"></i> Import
              </Nav.Link>
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-upload-2-line me-3"></i> Export
              </Nav.Link>
              <Nav.Link href="" className="rounded-3 mb-2">
                <i className="ri-printer-line me-3"></i> Print
              </Nav.Link>
            </Nav>

          </PerfectScrollbar>
          <div className="contact-body">
            <div className="contact-list">
              <div className="contact-list-header bg-white shadow-sm rounded-3 p-3 mb-3">
                <Link onClick={sidebarShow} href="#" className="contact-menu d-xl-none btn btn-outline-primary rounded-circle me-3">
                  <i className="ri-arrow-left-line"></i>
                </Link>
                <h5 className="sidebar-title me-auto mb-0 fw-bold text-primary">
                  <i className="ri-contacts-line me-2"></i>All Contacts
                </h5>

                <Dropdown align="end">
                  <Dropdown.Toggle as={CustomToggle} className="btn btn-outline-primary rounded-circle">
                    <i className="ri-more-2-fill"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow-lg border-0 rounded-3">
                    <Dropdown.Item href="" className="rounded-2 mb-1">
                      <i className="ri-contacts-book-2-line me-2"></i> Display Density
                    </Dropdown.Item>
                    <Dropdown.Item href="" className="rounded-2 mb-1">
                      <i className="ri-list-check-2 me-2"></i> Filter Contacts
                    </Dropdown.Item>
                    <Dropdown.Item href="" className="rounded-2">
                      <i className="ri-list-settings-line me-2"></i> Contact Settings
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <PerfectScrollbar className="contact-list-body">
                {contactGroup.map((contact, index) => (
                  <React.Fragment key={index}>
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" 
                           style={{ width: '40px', height: '40px' }}>
                        <span className="fw-bold">{contact.group}</span>
                      </div>
                      <h6 className="mb-0 fw-bold text-primary">{contact.group}</h6>
                    </div>
                    <div className="contact-group mb-4">
                      {contact.items.map((item, ind) => (
                        <div key={ind} className={`contact-item rounded-3 p-3 mb-2 shadow-sm ${item.selected ? "selected bg-primary bg-opacity-10 border border-primary" : "bg-white"}`}
                             style={{ transition: 'all 0.3s ease' }}
                             onMouseEnter={(e) => {
                               if (!item.selected) {
                                 e.currentTarget.style.transform = 'translateY(-2px)';
                                 e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                               }
                             }}
                             onMouseLeave={(e) => {
                               if (!item.selected) {
                                 e.currentTarget.style.transform = 'translateY(0)';
                                 e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
                               }
                             }}>
                          <div className="d-flex align-items-center">
                            <div className={"avatar me-3 " + item.status}>
                              {item.thumb && <img src={item.thumb} alt="" className="rounded-circle" />}
                              {item.initial && <span className={"avatar-initial text-white bg-" + item.initial + " rounded-circle"}>{contact.group}</span>}
                            </div>
                            <div className="contact-item-body flex-grow-1">
                              <div className="d-flex align-items-center mb-1">
                                <h6 className="mb-0 fw-semibold">{item.name}</h6>
                                <span className={`badge rounded-pill ms-2 ${item.status === 'online' ? 'bg-success' : 'bg-secondary'}`}>
                                  {item.status}
                                </span>
                              </div>
                              <span className="text-muted small">{item.contact}</span>
                            </div>
                            <Nav className="nav-icon">
                              <Nav.Link href="" className="btn btn-outline-warning btn-sm rounded-circle me-1">
                                <i className="ri-star-line"></i>
                              </Nav.Link>
                              <Nav.Link href="" className="btn btn-outline-primary btn-sm rounded-circle">
                                <i className="ri-pencil-line"></i>
                              </Nav.Link>
                            </Nav>
                          </div>
                        </div>
                      ))}
                    </div>
                  </React.Fragment>
                ))}
              </PerfectScrollbar>

            </div>

            <PerfectScrollbar className="contact-content">
              <Link id="contactClose" href="" className="contact-close btn btn-outline-danger rounded-circle">
                <i className="ri-close-fill"></i>
              </Link>
              <div className="bg-white rounded-4 shadow-lg p-4 mb-4">
                <div className="d-sm-flex align-items-center">
                  <div className="me-4 mb-3 mb-sm-0">
                    <Avatar img={img11} />
                  </div>
                  <div className="flex-fill">
                    <h4 className="mb-1 text-dark fw-bold">Abigaile Johnson</h4>
                    <p className="text-muted mb-3">Software Engineer at Themepixels, Inc.</p>
                    <div className="d-flex gap-2">
                      <Button variant="primary" className="px-4 py-2 rounded-pill fw-semibold">
                        <i className="ri-message-3-line me-2"></i>Message
                      </Button>
                      <Button variant="outline-warning" className="btn-icon rounded-circle">
                        <i className="ri-star-line"></i>
                      </Button>
                      <Button variant="outline-secondary" className="btn-icon rounded-circle">
                        <i className="ri-more-fill"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-4 shadow-lg p-4 mb-4">
                <h6 className="fw-bold text-primary mb-3">
                  <i className="ri-information-line me-2"></i>Contact Information
                </h6>
                <Row className="mb-3">
                  <Col xs="4" className="text-end text-secondary fw-semibold">Status</Col>
                  <Col>
                    <span className="badge bg-warning text-dark">Do Not Disturb</span>
                    <p className="mt-2 mb-0 small">Gambler, Tea Drinker, Ultimate Piggie, Replacement President of a Major Soft Drink Manufacturer. When I give out candies, I give people the flavour I don't like.</p>
                  </Col>
                </Row>

                <hr />

                <Row className="mb-3">
                  <Col xs="4" className="text-end text-secondary fw-semibold">
                    <i className="ri-mail-line me-1"></i>Email
                  </Col>
                  <Col>
                    <div className="d-flex flex-column">
                      <span className="mb-1">abigaile@johnson.com</span>
                      <span>ajohnson@gmail.com</span>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs="4" className="text-end text-secondary fw-semibold">
                    <i className="ri-phone-line me-1"></i>Phone
                  </Col>
                  <Col>234-5678-901</Col>
                </Row>
                <Row className="mb-3">
                  <Col xs="4" className="text-end text-secondary fw-semibold">
                    <i className="ri-map-pin-line me-1"></i>Location
                  </Col>
                  <Col>Bay Area, San Francisco, CA</Col>
                </Row>
              </div>

              <div className="bg-white rounded-4 shadow-lg p-4">
                <h6 className="fw-bold text-primary mb-3">
                  <i className="ri-settings-3-line me-2"></i>Actions
                </h6>
                <Nav className="nav-sidebar flex-column">
                  <Nav.Link href="" className="rounded-3 mb-2 p-3">
                    <i className="ri-check-double-line me-3 text-success"></i> Activity
                  </Nav.Link>
                  <Nav.Link href="" className="rounded-3 mb-2 p-3">
                    <i className="ri-list-check-2 me-3 text-info"></i> Call &amp; Message Logs
                  </Nav.Link>
                  <Nav.Link href="" className="rounded-3 mb-2 p-3">
                    <i className="ri-share-forward-line me-3 text-primary"></i> Share Contact
                  </Nav.Link>
                  <Nav.Link href="" className="rounded-3 mb-2 p-3">
                    <i className="ri-forbid-line me-3 text-warning"></i> Block Contact
                  </Nav.Link>
                  <Nav.Link href="" className="rounded-3 p-3">
                    <i className="ri-delete-bin-line me-3 text-danger"></i> Delete Contact
                  </Nav.Link>
                </Nav>
              </div>

            </PerfectScrollbar>

          </div>
        </div>

        <Footer />
      </div>
    </React.Fragment>
  );
}